import React from "react"
import { IJobConsolidatedTimecardDay, IJobConsolidatedTimecard } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import moment from "moment"
import * as timeHelper from "../../../helpers/timeHelper"
import { grey500 } from "material-ui/styles/colors"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
    timecard: IJobConsolidatedTimecard
}

const ConsolidatedTimecardEmployeeInnerTable: React.SFC<IProps> = (props: IProps) => {
    const dayCount = props.timecard.Days.length
    return (
        <div style={{ marginLeft: 15, display: "flex" }}>
            {/* Pay Category, Pay Type and Pay Rate columns */}
            <div style={{ flex: 3 }}>
                <Table displaySelectAll={false} selectable={false} multiSelectable={false} wrapperStyle={{ width: "fit-content", overflow: "unset" }}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn style={payCategoryHeadColStyle}>{strings.Pay_Category}
                                <i
                                    className="fa fa-info-circle"
                                    style={{ fontSize: 12, marginLeft: 3 }}
                                    title={strings.Job_Consolidate_Pay_Category_Tooltip}
                                />
                            </TableHeaderColumn>
                            <TableHeaderColumn style={headColStyle}>{strings.Pay_Type}
                                <i
                                    className="fa fa-info-circle"
                                    style={{ fontSize: 12, marginLeft: 3 }}
                                    title={strings.Job_Consolidate_PayType_Tooltip}
                                />
                            </TableHeaderColumn>
                            <TableHeaderColumn style={headColStyle}>{strings.Pay_Rate}
                                <i
                                    className="fa fa-info-circle"
                                    style={{ fontSize: 12, marginLeft: 3 }}
                                    title={strings.AveragePayRate}
                                />
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false}>
                        {/* REG Pay Category */}
                        <TableRow data-intercom-target={`Select-1`} key={-1} >
                            <TableRowColumn
                                colSpan={3}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            <TableRowColumn style={payCategoryHeadColStyle}>
                                                {strings.RegularHours}
                                            </TableRowColumn>
                                            <TableRowColumn style={colStyle} />
                                            <TableRowColumn style={colStyle}>
                                                {getAverageWeeklyRate(props.timecard.TimeTotals.TotalRegularPay, props.timecard.TimeTotals.RegularHours)}
                                            </TableRowColumn>
                                        </TableRow>
                                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalRegMinutes > 0).map(i => {
                                            const payTypeTotal = props.timecard.TimeTotals.ProductiveTimePayTypeTotals.find(e => e.PayTypeId === i.PayTypeId)
                                            return (
                                                <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                    <TableRowColumn style={payTypeRowColStyle} />
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {payTypeTotal.PayTypeName}
                                                    </TableRowColumn>
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {getAverageWeeklyRate(payTypeTotal.TotalRegPay, payTypeTotal.TotalRegHours)}
                                                    </TableRowColumn>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>

                        {/* OT Pay Category */}
                        <TableRow data-intercom-target={`Select-1`} key={-2} >
                            <TableRowColumn
                                colSpan={3}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            <TableRowColumn style={payCategoryHeadColStyle}>
                                                {strings.OvertimeHours}
                                            </TableRowColumn>
                                            <TableRowColumn style={colStyle} />
                                            <TableRowColumn style={colStyle}>
                                                {getAverageWeeklyRate(props.timecard.TimeTotals.TotalOTPay, props.timecard.TimeTotals.OvertimeHours)}
                                            </TableRowColumn>
                                        </TableRow>
                                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalOTMinutes > 0).map(i => {
                                            const payTypeTotal = props.timecard.TimeTotals.ProductiveTimePayTypeTotals.find(e => e.PayTypeId === i.PayTypeId)
                                            return (
                                                <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                    <TableRowColumn style={payTypeRowColStyle} />
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {payTypeTotal.PayTypeName}
                                                    </TableRowColumn>
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {getAverageWeeklyRate(payTypeTotal.TotalOTPay, payTypeTotal.TotalOTHours)}
                                                    </TableRowColumn>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>

                        {/* OT2 Pay Category */}
                        {!AccountStore.getHideOT2() &&
                            <TableRow data-intercom-target={`Select-1`} key={-3} >
                                <TableRowColumn
                                    colSpan={3}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                <TableRowColumn style={payCategoryHeadColStyle}>
                                                    {strings.DoubleOvertimeHours}
                                                </TableRowColumn>
                                                <TableRowColumn style={colStyle} />
                                                <TableRowColumn style={colStyle}>
                                                    {getAverageWeeklyRate(props.timecard.TimeTotals.TotalOT2Pay, props.timecard.TimeTotals.DoubleOvertimeHours)}
                                                </TableRowColumn>
                                            </TableRow>
                                            {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalOT2Minutes > 0).map(i => {
                                                const payTypeTotal = props.timecard.TimeTotals.ProductiveTimePayTypeTotals.find(e => e.PayTypeId === i.PayTypeId)
                                                return (
                                                    <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                        <TableRowColumn style={payTypeRowColStyle} />
                                                        <TableRowColumn style={payTypeRowColStyle}>
                                                            {payTypeTotal.PayTypeName}
                                                        </TableRowColumn>
                                                        <TableRowColumn style={payTypeRowColStyle}>
                                                            {getAverageWeeklyRate(payTypeTotal.TotalOT2Pay, payTypeTotal.TotalOT2Hours)}
                                                        </TableRowColumn>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        }

                        {/* Hours for NonOverTime PayType  */}
                        {props.timecard.TimeTotals.PayTypeTotals.filter(i => i.TotalHours > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`NonOTHours${index}`} >
                                <TableRowColumn
                                    colSpan={3}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow>
                                                <TableRowColumn style={payCategoryColStyle}>
                                                    {payTypeTotal.PayTypeName}
                                                </TableRowColumn>
                                                <TableRowColumn style={colStyle} />
                                                <TableRowColumn style={colStyle}>
                                                    {getAverageWeeklyRate(payTypeTotal.TotalPay - payTypeTotal.TotalAmount, payTypeTotal.TotalHours)}
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}

                        {/* AmountExpense for OverTime PayType  */}
                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalAmount > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`OTAmountExpense${index}`} >
                                <TableRowColumn
                                    colSpan={3}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow>
                                                <TableRowColumn style={payCategoryColStyle}>
                                                    <i
                                                        className="fa fa-info-circle"
                                                        style={{ fontSize: 12, marginRight: 3, color: grey500 }}
                                                        title={strings.Expense_Amount_Data}
                                                    />
                                                    {payTypeTotal.PayTypeName}
                                                </TableRowColumn>
                                                <TableRowColumn style={colStyle} />
                                                <TableRowColumn style={colStyle}>
                                                    {getAverageWeeklyRate(payTypeTotal.TotalAmount, 0)}
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}
                        {/* AmountExpense for NonOverTime PayType  */}
                        {props.timecard.TimeTotals.PayTypeTotals.filter(i => i.TotalAmount > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`NonOTAmountExpense${index}`} >
                                <TableRowColumn
                                    colSpan={3}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow>
                                                <TableRowColumn style={payCategoryColStyle}>
                                                    <i
                                                        className="fa fa-info-circle"
                                                        style={{ fontSize: 12, marginRight: 3, color: grey500 }}
                                                        title={strings.Expense_Amount_Data}
                                                    />
                                                    {payTypeTotal.PayTypeName}
                                                </TableRowColumn>
                                                <TableRowColumn style={colStyle} />
                                                <TableRowColumn style={colStyle}>
                                                    {getAverageWeeklyRate(payTypeTotal.TotalAmount, 0)}
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}
                        <TableRow data-intercom-target={`Select-1`} key={-4} >
                            <TableRowColumn
                                colSpan={3}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow>
                                            <TableRowColumn style={payCategoryColStyle}>
                                                {strings.Total}
                                            </TableRowColumn>
                                            <TableRowColumn style={colStyle} />
                                            <TableRowColumn style={colStyle}>
                                                {getAverageWeeklyRate(props.timecard.TimeTotals.TotalPay, props.timecard.TimeTotals.TotalHours)}
                                            </TableRowColumn>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>

            {/* Days columns */}
            <div style={{ flex: dayCount, overflow: "auto" }}>
                <Table displaySelectAll={false} selectable={false} multiSelectable={false} wrapperStyle={{ width: "fit-content", overflow: "unset" }}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            {props.timecard.Days.map((day, index) =>
                                <TableHeaderColumn style={headColStyle} key={index}>{moment(timeHelper.keepConvertUTCToLocal(day.LocalStartDayTime)).format("DD-MMM-YY")}</TableHeaderColumn>
                            )}
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false}>
                        {/* REG Pay Category */}
                        <TableRow data-intercom-target={`Select-1`} key={-1} >
                            <TableRowColumn
                                colSpan={dayCount}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            {props.timecard.Days.map((day, index) =>
                                                <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, "reg")}</TableRowColumn>
                                            )}
                                        </TableRow>
                                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalRegMinutes > 0).map(i => {
                                            return (
                                                <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                    {props.timecard.Days.map((day, index) =>
                                                        <TableRowColumn style={payTypeRowColStyle} key={index}>
                                                            <div>
                                                                {(() => {
                                                                    const dayPayTypeTotal = day.TimeTotals.ProductiveTimePayTypeTotals.find(item => item.PayTypeId == i.PayTypeId)
                                                                    return dayPayTypeTotal && dayPayTypeTotal.TotalRegHours ? dayPayTypeTotal.TotalRegHours : ""
                                                                })()}
                                                            </div>
                                                        </TableRowColumn>
                                                    )}
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>

                        {/* OT Pay Category */}
                        <TableRow data-intercom-target={`Select-1`} key={-2} >
                            <TableRowColumn
                                colSpan={dayCount}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            {props.timecard.Days.map((day, index) =>
                                                <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, "ot")}</TableRowColumn>
                                            )}
                                        </TableRow>
                                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalOTMinutes > 0).map(i => {
                                            return (
                                                <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                    {props.timecard.Days.map((day, index) =>
                                                        <TableRowColumn style={payTypeRowColStyle} key={index}>
                                                            <div>
                                                                {(() => {
                                                                    const dayPayTypeTotal = day.TimeTotals.ProductiveTimePayTypeTotals.find(item => item.PayTypeId == i.PayTypeId)
                                                                    return dayPayTypeTotal && dayPayTypeTotal.TotalOTHours ? dayPayTypeTotal.TotalOTHours : ""
                                                                })()}
                                                            </div>
                                                        </TableRowColumn>
                                                    )}
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>

                        {/* OT2 Pay Category */}
                        {!AccountStore.getHideOT2() &&
                            <TableRow data-intercom-target={`Select-1`} key={-3} >
                                <TableRowColumn
                                    colSpan={dayCount}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                {props.timecard.Days.map((day, index) =>
                                                    <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, "ot2")}</TableRowColumn>
                                                )}
                                            </TableRow>
                                            {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalOT2Minutes > 0).map(i => {
                                                return (
                                                    <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                        {props.timecard.Days.map((day, index) =>
                                                            <TableRowColumn style={payTypeRowColStyle} key={index}>
                                                                <div>
                                                                    {(() => {
                                                                        const dayPayTypeTotal = day.TimeTotals.ProductiveTimePayTypeTotals.find(item => item.PayTypeId == i.PayTypeId)
                                                                        return dayPayTypeTotal && dayPayTypeTotal.TotalOT2Hours ? dayPayTypeTotal.TotalOT2Hours : ""
                                                                    })()}
                                                                </div>
                                                            </TableRowColumn>
                                                        )}
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        }

                        {/* Hours for NonOverTime PayType  */}
                        {props.timecard.TimeTotals.PayTypeTotals.filter(i => i.TotalHours > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`NonOTHours${index}`} >
                                <TableRowColumn
                                    colSpan={dayCount}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                {props.timecard.Days.map((day, index) =>
                                                    <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, payTypeTotal.PayTypeId)}</TableRowColumn>
                                                )}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}

                        {/* AmountExpense for OverTime PayType  */}
                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalAmount > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`OTAmountExpense${index}`} >
                                <TableRowColumn
                                    colSpan={dayCount}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                {props.timecard.Days.map((day, index) =>
                                                    <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, payTypeTotal.PayTypeId, true)}</TableRowColumn>
                                                )}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}
                        {/* AmountExpense for NonOverTime PayType  */}
                        {props.timecard.TimeTotals.PayTypeTotals.filter(i => i.TotalAmount > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`NonOTAmountExpense${index}`} >
                                <TableRowColumn
                                    colSpan={dayCount}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                {props.timecard.Days.map((day, index) =>
                                                    <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, payTypeTotal.PayTypeId, false, true)}</TableRowColumn>
                                                )}
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}
                        <TableRow data-intercom-target={`Select-1`} key={-4} >
                            <TableRowColumn
                                colSpan={dayCount}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            {props.timecard.Days.map((day, index) =>
                                                <TableRowColumn style={colStyle} key={index}>{getTotalPerDay(day, "total")}</TableRowColumn>
                                            )}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>

            {/* Hours and Amount columns */}
            <div style={{ flex: 2 }}>
                <Table displaySelectAll={false} selectable={false} multiSelectable={false} wrapperStyle={{ width: "fit-content", overflow: "unset" }}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn style={headColStyle}>{strings.Hours}</TableHeaderColumn>
                            <TableHeaderColumn style={headColStyle}>{strings.Amount}</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false}>
                        {/* REG Pay Category */}
                        <TableRow data-intercom-target={`Select-1`} key={-1} >
                            <TableRowColumn
                                colSpan={2}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            <TableRowColumn style={colStyle}>
                                                {props.timecard.TimeTotals.RegularHours}
                                            </TableRowColumn>
                                            <TableRowColumn style={colStyle}>
                                                {formatter.format(props.timecard.TimeTotals.TotalRegularPay)}
                                            </TableRowColumn>
                                        </TableRow>
                                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalRegMinutes > 0).map(i => {
                                            const payTypeTotal = props.timecard.TimeTotals.ProductiveTimePayTypeTotals.find(e => e.PayTypeId === i.PayTypeId)
                                            return (
                                                <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {payTypeTotal.TotalRegHours}
                                                    </TableRowColumn>
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {formatter.format(payTypeTotal.TotalRegPay)}
                                                    </TableRowColumn>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>

                        {/* OT Pay Category */}
                        <TableRow data-intercom-target={`Select-1`} key={-2} >
                            <TableRowColumn
                                colSpan={2}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            <TableRowColumn style={colStyle}>
                                                {props.timecard.TimeTotals.OvertimeHours}
                                            </TableRowColumn>
                                            <TableRowColumn style={colStyle}>
                                                {formatter.format(props.timecard.TimeTotals.TotalOTPay)}
                                            </TableRowColumn>
                                        </TableRow>
                                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalOTMinutes > 0).map(i => {
                                            const payTypeTotal = props.timecard.TimeTotals.ProductiveTimePayTypeTotals.find(e => e.PayTypeId === i.PayTypeId)
                                            return (
                                                <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {payTypeTotal.TotalOTHours}
                                                    </TableRowColumn>
                                                    <TableRowColumn style={payTypeRowColStyle}>
                                                        {formatter.format(payTypeTotal.TotalOTPay)}
                                                    </TableRowColumn>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>

                        {/* OT2 Pay Category */}
                        {!AccountStore.getHideOT2() &&
                            <TableRow data-intercom-target={`Select-1`} key={-3} >
                                <TableRowColumn
                                    colSpan={2}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                <TableRowColumn style={colStyle}>
                                                    {props.timecard.TimeTotals.DoubleOvertimeHours}
                                                </TableRowColumn>
                                                <TableRowColumn style={colStyle}>
                                                    {formatter.format(props.timecard.TimeTotals.TotalOT2Pay)}
                                                </TableRowColumn>
                                            </TableRow>
                                            {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalOT2Minutes > 0).map(i => {
                                                const payTypeTotal = props.timecard.TimeTotals.ProductiveTimePayTypeTotals.find(e => e.PayTypeId === i.PayTypeId)
                                                return (
                                                    <TableRow data-intercom-target={`Select-1`} key={i.PayTypeId} style={{ border: "none", height: 25 }}>
                                                        <TableRowColumn style={payTypeRowColStyle}>
                                                            {payTypeTotal.TotalOT2Hours}
                                                        </TableRowColumn>
                                                        <TableRowColumn style={payTypeRowColStyle}>
                                                            {formatter.format(payTypeTotal.TotalOT2Pay)}
                                                        </TableRowColumn>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        }

                        {/* Hours for NonOverTime PayType  */}
                        {props.timecard.TimeTotals.PayTypeTotals.filter(i => i.TotalHours > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`NonOTHours${index}`} >
                                <TableRowColumn
                                    colSpan={2}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                <TableRowColumn style={colStyle}>{payTypeTotal.TotalHours}</TableRowColumn>
                                                <TableRowColumn style={colStyle}>
                                                    {formatter.format(payTypeTotal.TotalPay - payTypeTotal.TotalAmount)}
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}

                        {/* AmountExpense for OverTime PayType  */}
                        {props.timecard.TimeTotals.ProductiveTimePayTypeTotals.filter(i => i.TotalAmount > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`OTAmountExpense${index}`} >
                                <TableRowColumn
                                    colSpan={2}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                <TableRowColumn style={colStyle}>0</TableRowColumn>
                                                <TableRowColumn style={colStyle}>
                                                    {formatter.format(payTypeTotal.TotalAmount)}
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}
                        {/* AmountExpense for NonOverTime PayType  */}
                        {props.timecard.TimeTotals.PayTypeTotals.filter(i => i.TotalAmount > 0).map((payTypeTotal, index) =>
                            <TableRow data-intercom-target={`Select${index}`} key={`NonOTAmountExpense${index}`} >
                                <TableRowColumn
                                    colSpan={2}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ border: "none" }}>
                                                <TableRowColumn style={colStyle}>0</TableRowColumn>
                                                <TableRowColumn style={colStyle}>
                                                    {formatter.format(payTypeTotal.TotalAmount)}
                                                </TableRowColumn>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )}
                        <TableRow data-intercom-target={`Select-1`} key={-4}>
                            <TableRowColumn
                                colSpan={2}
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                            >
                                <Table displaySelectAll={false} selectable={false} multiSelectable={false}>
                                    <TableBody displayRowCheckbox={false}>
                                        <TableRow style={{ border: "none" }}>
                                            <TableRowColumn style={colStyle}>
                                                {props.timecard.TimeTotals.TotalHours}
                                            </TableRowColumn>
                                            <TableRowColumn style={colStyle}>
                                                {formatter.format(props.timecard.TimeTotals.TotalPay)}
                                            </TableRowColumn>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableRowColumn>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        </div>
    )
}

export default ConsolidatedTimecardEmployeeInnerTable

const payCategoryHeadColStyle = { textAlign: "center", width: 85, paddingLeft: 5, paddingRight: 5 }
const payCategoryColStyle = { textAlign: "center", width: 85, paddingLeft: 5, paddingRight: 5, fontWeight: 600 }
const headColStyle = { textAlign: "center", width: 60, paddingLeft: 5, paddingRight: 5 }
const colStyle = { textAlign: "center", width: 60, paddingLeft: 5, paddingRight: 5, fontWeight: 600 }
const payTypeRowColStyle = { textAlign: "center", width: 60, paddingLeft: 5, paddingRight: 5, height: 25 }
const getAverageWeeklyRate = (totalAmount: number, totalTime: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    if (totalAmount == 0 && totalTime != 0) {
        return "$0.00"
    }

    if (totalAmount == 0 || totalTime == 0) {
        return ""
    }

    return formatter.format(totalAmount / totalTime)
}
const getTotalPerDay = (timecardDay: IJobConsolidatedTimecardDay, payTypeId: string, productiveTimePayTypeAmountTotal: boolean = false, payTypeAmountTotal: boolean = false) => {
    if (payTypeId == "reg") {
        return timecardDay.TimeTotals.RegularHours == 0 ? "" : timecardDay.TimeTotals.RegularHours
    }
    else if (payTypeId == "ot") {
        return timecardDay.TimeTotals.OvertimeHours == 0 ? "" : timecardDay.TimeTotals.OvertimeHours
    }
    else if (payTypeId == "ot2") {
        return timecardDay.TimeTotals.DoubleOvertimeHours == 0 ? "" : timecardDay.TimeTotals.DoubleOvertimeHours
    }
    else if (payTypeId == "total") {
        return timecardDay.TimeTotals.TotalHours == 0 ? "" : timecardDay.TimeTotals.TotalHours
    }
    else {
        if (productiveTimePayTypeAmountTotal) {
            const payTypeTotalItem = timecardDay.TimeTotals.ProductiveTimePayTypeTotals.find(item => item.PayTypeId == payTypeId)
            return payTypeTotalItem && payTypeTotalItem.TotalAmount ? formatter.format(payTypeTotalItem.TotalAmount) : ""
        }
        else if (payTypeAmountTotal) {
            const payTypeTotalItem = timecardDay.TimeTotals.PayTypeTotals.find(item => item.PayTypeId == payTypeId)
            return payTypeTotalItem && payTypeTotalItem.TotalAmount ? formatter.format(payTypeTotalItem.TotalAmount) : ""
        }
        else {
            const payTypeTotalItem = timecardDay.TimeTotals.PayTypeTotals.find(item => item.PayTypeId == payTypeId)
            return payTypeTotalItem && payTypeTotalItem.TotalHours ? payTypeTotalItem.TotalHours : ""
        }
    }
}
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})